bovoApp.controller('TrackingAdController', ['$scope', 'TrackingAd', '$location', '$routeParams', '$filter', '$translate',
  function ($scope, TrackingAd, $location, $routeParams, $filter, $translate) {
    $scope.deleted = [];
    $scope.uploading = { web: false, mobile: false };

    $scope.all = function () {
      TrackingAd.all().success(function (data) {
        $scope.data = data;
      });
    }

    $scope.openDetail = function (item) {
      TrackingAd.get(item.id).success(function (data) {
        $('#trackingAdModal').modal('show');
        $scope.trackingAd = data.trackingAd;
      });
    }

    $scope.$on('new_data', function () {
      $('#trackingAdModal').modal('show');
      $scope.new();
    }, true);

    $scope.new = function () {
      TrackingAd.new().success(function () {
        $scope.trackingAd = {
          status: 'active',
          duration: 3,
          show_after: 0,
          web_media_type: 'image',
          mobile_media_type: null
        };
      });
    }

    $scope.delete = function (type) {
      if (type == 'set') {
        $('#delete').modal('show');
      } else if (type == 'delete') {
        var ids = $scope.deleted.slice();
        var remaining = ids.length;
        if (remaining === 0) {
          $('#delete').modal('hide');
          return;
        }
        ids.forEach(function (id) {
          TrackingAd.delete(id).success(function () {
            remaining--;
            if (remaining === 0) {
              Messenger().post('Silindi');
              $scope.deleted = [];
              $('#delete').modal('hide');
              $scope.all();
            }
          }).error(function (data) {
            Messenger().post({ message: (data && data.message) || 'Silinemedi', type: "error" });
          });
        });
      }
    }

    $scope.postForm = function () {
      if (!$scope.trackingAd || !$scope.trackingAd.web_media_url) {
        Messenger().post({ message: 'Web görseli/videosu zorunludur', type: 'error' });
        return;
      }
      if ($scope.trackingAd.id) {
        $scope.update();
      } else {
        $scope.save();
      }
    }

    $scope.save = function () {
      TrackingAd.save($scope.trackingAd).success(function () {
        Messenger().post('Başarılı');
        $('#trackingAdModal').modal('hide');
        $scope.all();
      }).error(function (data) {
        Messenger().post({ message: data.message, type: "error" });
      });
    }

    $scope.update = function () {
      TrackingAd.update($scope.trackingAd).success(function () {
        Messenger().post('Başarılı');
        $('#trackingAdModal').modal('hide');
        $scope.all();
      }).error(function (data) {
        Messenger().post({ message: data.message, type: "error" });
      });
    }

    $scope.toggleSelection = function (id) {
      var idx = $scope.deleted.indexOf(id);
      if (idx > -1) {
        $scope.deleted.splice(idx, 1);
      } else {
        $scope.deleted.push(id);
      }
    };

    /**
     * target: 'web' veya 'mobile'
     */
    $scope.onMediaSelected = function (target, event) {
      var file = event.target.files && event.target.files[0];
      if (!file) return;

      $scope.uploading[target] = true;
      TrackingAd.uploadMedia(file, target).success(function (resp) {
        if (!$scope.trackingAd) $scope.trackingAd = {};
        if (target === 'web') {
          $scope.trackingAd.web_media_url = resp.url;
          $scope.trackingAd.web_media_type = resp.media_type;
        } else {
          $scope.trackingAd.mobile_media_url = resp.url;
          $scope.trackingAd.mobile_media_type = resp.media_type;
        }
        $scope.uploading[target] = false;
        // input'u sıfırla ki aynı dosya tekrar seçilebilsin
        event.target.value = '';
      }).error(function (data) {
        $scope.uploading[target] = false;
        Messenger().post({ message: (data && data.message) || 'Yükleme başarısız', type: "error" });
        event.target.value = '';
      });
    };

    $scope.clearMedia = function (target) {
      if (!$scope.trackingAd) return;
      if (target === 'web') {
        $scope.trackingAd.web_media_url = null;
        $scope.trackingAd.web_media_type = 'image';
      } else {
        $scope.trackingAd.mobile_media_url = null;
        $scope.trackingAd.mobile_media_type = null;
      }
    };

    /**
     * İstatistik modalını açar.
     */
    $scope.openStats = function (item, event) {
      if (event) event.stopPropagation();
      $scope.statsDays = 30;
      $scope.statsLoading = true;
      $scope.statsAd = item;
      $scope.stats = null;
      $('#trackingAdStatsModal').modal('show');
      TrackingAd.stats(item.id, $scope.statsDays).success(function (data) {
        $scope.stats = data;
        $scope.statsLoading = false;
      }).error(function () {
        $scope.statsLoading = false;
        Messenger().post({ message: 'İstatistikler yüklenemedi', type: 'error' });
      });
    };

    $scope.reloadStats = function () {
      if (!$scope.statsAd) return;
      $scope.statsLoading = true;
      TrackingAd.stats($scope.statsAd.id, $scope.statsDays).success(function (data) {
        $scope.stats = data;
        $scope.statsLoading = false;
      });
    };
  }
]);
